export const TOOLTIPS_TEXTS = {
  usersTable: {
    userName: 'Indicates the first name of the user.',
    email:
      "Indicates the email address of the user which is also the user's username for their access credentials.",
    mobilePhone: 'Indicates the mobile phone number of the user.',
    role: 'Indicates the access level assigned to the user.',
    jobTitle: 'Indicates the job title of the user.',
    division: 'Indicates the assigned division(s) of the user.'
  },
  divisionsTable: {
    name: "Indicates the name of the Builder's Division.",
    city: "Indicates the city of the Builder's Division's location.",
    state: "Indicates the state / province of the Builder's Division's location.",
    phone: "Indicates the main phone number of the Builder's Division.",
    disabledSync: 'Sync with 149Photos for this division is in progress.'
  },
  communitiesTable: {
    name: 'Indicates the community name.',
    division:
      "Indicates the name of the builder's division' that should be assigned to the community.",
    city: "Indicates the city of the community's physical address.",
    state: 'Indicates the state / province of the community`s physical address.'
  },
  contactsTable: {
    name: 'Indicates the name of the contact.',
    jobTitle: 'Indicates the job title of the contact.',
    contactType: 'Indicates the type of the contact.',
    companyType: 'Indicates the type of the contact company.',
    company: 'Indicates the name of contact company.',
    email: 'Indicates email of the contact.',
    phone: 'Indicates the mobile phone number of the contact.',
    division: 'Indicates the assigned division of the contact.',
    community: 'Indicates the assigned community of the contact.'
  },
  contactTypesTable: {
    name: 'Indicates the name of the contact type.',
    companyType: 'Indicates the company type of contact type.',
    description: 'Indicates the description of the contact type.'
  },
  contactVendorsTable: {
    name: 'Indicates the name of the vendor.',
    state: 'Indicates the state where the vendor is situated'
  },
  phasesTable: {
    order:
      'Indicates the desired order of the corresponding phases of construction as it should appear to the homeowner.',
    name: 'Indicates the name of the phase of construction as it should appear to the homeowner.',
    description:
      'Indicates the description of the phase of construction as it should appear to the homeowner.',
    assignedDivisions: 'Indicates assigned divisions',
    video: 'Indicates if a supporting video has been uploaded for the phase of construction.'
  },
  phaseTipsTable: {
    order: 'Indicates the desired order of the phase tip as it should appear to the homeowner.',
    name: 'Indicates the name of the phase tip as it should appear to the homeowner.',
    description: 'Indicates the description of the phase tip as it should appear to the homeowner.'
  },
  plansTable: {
    name: 'Indicates the name of the plan.',
    divisions: 'Indicates the divisions that the plan has been made available to.',
    communities: 'Indicates the communities that the plan has been made available to.',
    elevationsCount: 'Indicates the number of elevations that have been configured for the plan.'
  },
  planForm: {
    planName: 'Enter the name of the plan.',
    plansAssigments: 'Indicates to what communities the plan should be assigned'
  },
  elevationsTable: {
    name: 'Indicates the name of the elevation',
    order: 'Indicates the order of the elevation in plan.'
  },
  elevationForm: {
    name: 'Enter the name of the elevation.'
  },
  userForm: {
    firstName: 'Enter the first name of the user.',
    lastName: 'Enter the last name of the user.',
    groupName: 'Enter the name of the group.',
    groupMembersNames: 'Enter the names of the group members.',
    email:
      "Enter the email address of the user. This will become the user's username for their access credentials.",
    jobTitle:
      'Enter the job title of the user. This title may be used and shown to homeowners via their account in the mobile and responsive web applications.',
    mobilePhone: 'Enter the mobile phone number of the user.',
    workPhone: 'Enter the work phone number of the user.',
    homescreen: 'Select the default screen the user would prefer to see at sign in.',
    role: 'Select the access level desired for the user.',
    roleSelected: 'Access Level of the user',
    headshot:
      "Upload the user's desired photo. This image may be used and shown to homeowners via their account in the mobile and responsive web applications.",
    divisionsAssignment:
      'Select all divisions the user should have access to. Check all that apply.',
    communitiesAssignment:
      'Select all communities the user should have access to. Check all that apply.',
    notifications:
      'Select the desired notification settings for the user. Notifications are sent via text and email related to actions taken within the system.',
    permissions:
      'Select the desired permissions for the user indicating which sections of the portal the user should have access to. Check all that apply.',
    disabledPermissions: 'You have edit rights only for own permissions',
    notificationItems: {
      photos:
        "These notifications are sent when new home photo(s)/video(s) are uploaded to the homeowner's photo gallery.",
      messages:
        'These notifications are sent when a homeowner sends a new message via the in-app messaging feature.',
      schedule:
        'These notifications are sent when a homeowner responds to any invitation sent to the homeowner via the scheduling feature.',
      documents:
        "These notifications are sent when new document(s) are uploaded to the homeowner's documents.",
      updates: 'These notifications are sent when a new update(s) are delivered to the homeowner.',
      reports:
        'These notifications are sent when the user wishes to receive the monthly dashboard report.',
      general: 'These notifications are sent for events such as when a home changes phase.'
    }
  },
  divisionForm: {
    name: "Enter the name of the Builder's Division.",
    url: "Enter the website URL for the Builder's Division.",
    address: "Enter the street address of the Builder's Division.",
    city: "Enter the city of the Builder's Division.",
    state: "Select the state / province of the Builder's Division.",
    zip: "Enter the postal code of the Builder's Division.",
    country: "Select the country of the Builder's Division.",
    phone: "Enter the main phone number for the Builder's Division.",
    primaryContactId: "Select the Primary Contact for the Builder's Division.",
    primaryContactEmail:
      "Enter the email address of the Builder's primary contact for this Division.",
    primaryContactPhone:
      "Enter the phone number of the Builder's primary contact for this Division.",
    logo: 'Upload the desired Division logo.',
    phases: 'Select phases to assign to division. Check all that apply.',
    designStudioUrl: 'Enter the design studio url.',
    division149Photos: 'Select whether you are using 149Photos.',
    division149PhotosId: 'Enter the 149Photos ID.',
    timeZone: 'Select the time zone for this division.'
  },
  eventForm: {
    name: 'Enter the event name',
    description: 'Enter a description of the event',
    rsvpRequired: 'Choose whether or not you will require RSVPs from your invitees',
    estimatedDuration: 'Please select the estimated duration of the event, in hours',
    phases: 'Select the phases this event will be used in.',
    communitiesAssignment: 'Select all communities the event will be used in.'
  },
  communityForm: {
    communityName: 'Enter the name for the community.',
    division: "Select the builder's division that should be assigned to the community.",
    address: 'Enter the street address for the community`s physical address.',
    city: 'Enter the city for the community`s physical address.',
    state: "Select the state of the community's physical address.",
    zip: "Enter the postal code for the community's physical address."
  },
  contactForm: {
    companyType: 'Select the type of the contact company.',
    company: 'Select the company of the contact.',
    user: 'Select the user connected to a contact.',
    companyName: 'Enter the name of the contact company.',
    companyState: 'Enter the state of the contact company.',
    firstName: 'Enter the first name of the contact.',
    lastName: 'Enter the last name of the contact.',
    email: 'Enter the email of the contact.',
    jobTitle: 'Enter the job title of the contact.',
    phone: 'Enter the mobile phone number of the contact.',
    showPhone: 'Show/hide contact phone number for the buyer',
    workPhone: 'Enter the work phone number of the contact.',
    type: 'Select the type of the contact.',
    description: 'Enter the description of the contact.',
    headshot:
      "Upload the contact's desired photo. This image may be used and shown to homeowners via their account in the mobile and responsive web applications.",
    communitiesAssignment:
      'Select all communities the contact should be part of. Check all that apply.',
    isGroupContact: 'Select if contact is grouped or not.',
    groupName: 'Enter the name of the contact group.',
    groupMembersNames: 'Enter the names of the contact group members.'
  },
  contactTypeForm: {
    label: 'Enter the name of the contact type.',
    affiliation: 'Select the type of the contact type company.',
    description: 'Enter the description of the contact type.'
  },
  contactVendorForm: {
    name: 'Enter the name of the contact vendor.',
    state: 'Select the state of the vendor.'
  },
  phaseForm: {
    division: 'Indicates the assigned division of the phase of construction.',
    name: 'Enter the name of the phase of construction as it should appear to the homeowner.',
    description:
      'Enter the description of the phase of construction as it should appear to the homeowner.',
    videoUrl:
      'Enter the URL of an optional supporting video that you would like to associate with this phase of construction.',
    videoPreviewImage:
      'Upload the desired video preview image(i.e., the static image that will be used with play button overlay) that corresponds to the phase video.',
    divisionAssignments:
      'Select all divisions that should have this default phase. Check all that apply.'
  },
  phaseTipForm: {
    division: 'Indicates the assigned division of the phase of construction.',
    phase: 'Indicates the phase of construction this tip is associated with.',
    name: 'Enter the name of this phase tip as it should appear to the homeowner.',
    description: 'Enter the description of the phase tip as it should appear to the homeowner.'
  },
  defaultPhaseTipForm: {
    phase: 'Indicates the default phase of construction this default tip is associated with.',
    name: 'Enter the name of this default phase tip as it should appear to the homeowner.',
    description:
      'Enter the description of the default phase tip as it should appear to the homeowner.',
    divisionAssignments:
      'Select all divisions that should have this default phase tip. Check all that apply.'
  },
  eventsTable: {
    name: 'Indicates the name of the event template.',
    description: 'Indicates the description of the event template.',
    phases: 'Indicates which phases the event template has been made available to.',
    divisions: 'Indicates which divisions the event template has been made available to.',
    communities: 'Indicates which communities the event template has been made available to.'
  },
  homeScheduleTable: {
    date: 'Indicates date of the event.',
    time: 'Indicates time of the event.',
    name: 'Indicates the name of the event.',
    description: 'Indicates the description of the event.',
    phases: 'Indicates which phases the event has been made available to.',
    attendees: 'Indicates who is invited to the event.',
    status: 'Indicates which status selected event has.'
  },
  homeScheduleForm: {
    phase: 'Select the applicable phase for this home.',
    event: 'Select the event applicable for this home.',
    eventName: 'Please enter an event name for this home.',
    description: 'Enter a description of the event.',
    date: 'Indicates which phases the event has been made available to.',
    startTime: 'Indicates the start time of the event.',
    endTime: 'Indicates the end time of the event.',
    invitees: 'Select the invitees for this event.',
    rsvpRequired: 'Choose whether or not you will require RSVPs from your invitees.',
    streetAddressFirst: 'Enter the location street address 1.',
    streetAddressSecond: 'Enter the location street address 2.',
    city: 'Enter the city for the event`s physical address.',
    state: 'Select the state for the event`s physical address.',
    zip: 'Enter the postal code for this home.',
    requestedBy: 'Select who is requested for event.',
    status: 'Select the status.'
  },
  homeScheduleList: {
    phase: 'Indicates the phase of the event.',
    name: 'Indicates the name of the event.',
    description: 'Indicates the description of the event.',
    date: 'Indicates date of the event.',
    time: 'Indicates time of the event.',
    attendees: 'Indicates who is going to attend an event.',
    status: 'Indicates the status of the event.',
    rescheduledDate: 'Indicates the rescheduled date of the event.',
    rescheduledTime: 'Indicates the rescheduled time of the event.',
    address: 'Indicates the address of the event.',
    cityStateZip: 'Indicates the city, state and postal code of the home event.',
    invitees: 'Indicates who is invited to the event.',
    requestedBy: 'Indicates who the event was requested by.'
  },
  homeScheduleReschedule: {
    date: 'Indicates the date of the event.',
    start: 'Indicates the start time of the event.',
    end: 'Indicates the end time of the event.'
  },
  documentsTable: {
    name: 'Indicates the name of the document.',
    description: 'Indicates the description of the document.',
    fileSize: 'Indicates the file size of the document.',
    phases: 'Indicates which phases the document has been made available to.',
    divisions: 'Indicates which divisions the document has been made available to.',
    communities: 'Indicates which communities the document has been made available to.'
  },
  homeDocumentsTable: {
    name: 'Indicates the name of the document.',
    description: 'Indicates the description of the document.',
    fileSize: 'Indicates the file size of the document.',
    phases: 'Indicates which phases the document has been made available to.'
  },
  homesTable: {
    address: 'Indicates the physical street address of the home.',
    homesite: 'Indicates the lot / homesite # of the home.',
    plan: 'Indicates the name of the plan that applies to the home.',
    buyers: 'Indicates the name(s) of the buyer(s) of the home.',
    contractDate: 'Indicates the date that the contract was signed for the home.',
    lastLoggedIn: 'Indicates when the primary buyer last logged in.',
    contractCancelledDate: 'Indicates the date and time the home contract was cancelled.',
    division: `Indicates the division that the home's community belongs to.`,
    community: 'Indicates the community that the home belongs to.',
    phase: 'Indicates the current phase of construction that the home is in.'
  },
  homeForm: {
    division: 'Select the division this home belongs to.',
    community: 'Select the community this home belongs to.',
    plan: 'Select the plan that applies to this home.',
    elevation: 'Select the elevation that applies to this home.',
    homesite: 'Enter the homesite / lot number for this home.',
    elevationRendering:
      'If applicable, upload an elevation rendering that is specific to this home. Otherwise, you may accept the default rendering associated with the selected elevation.',
    address: 'Enter the address for this home.',
    city: 'Enter the city for this home.',
    state: 'Select the state/province for this home.',
    zip: 'Enter the postal code for this home.',
    buyerFirstName: 'Enter the first name of the primary buyer for this home.',
    buyerLastName: 'Enter the last name of the primary buyer for this home.',
    buyerEmail: 'Enter the email address of the primary buyer for this home.',
    buyerPhone: 'Enter the phone number of the primary buyer for this home.',
    coBuyerFirstName: 'Enter the first name of the co-buyer for this home, if applicable.',
    coBuyerLastName: 'Enter the last name of the co-buyer for this home, if applicable.',
    contractDate: 'Select the contract date for this home.',
    estimatedDeliveryDate: 'Select the estimated delivery date for this home.',
    closingDate: 'Select the closing date for this home.',
    phase: 'Select the applicable phase for this home.'
  },
  homeLoginsTable: {
    name: 'Indicates the name associated with the login.',
    type: 'Indicates the type of login.',
    email: 'Indicates the email address associated with the login.',
    phone: 'Indicates the phone number associated with the login.',
    status: `Indicates the activation status of the login. 'Pending' indicates that the login is NOT active, and cannot access the client app or desktop site. 'Activated' indicates that the login is active and CAN access the client app and desktop site.`,
    lastLoggedIn: 'Indicates when the buyer last logged in.'
  },
  homePhotos149Table: {
    date: 'Indicates the date when the photo/video was updated.',
    thumbnail: '',
    stage: 'Indicates the stage of the photo/video.'
  },
  homeLoginForm: {
    type: 'Indicates the type of login: Primary or Secondary.',
    status: 'Select the desired activation status of the login.',
    firstName: 'Enter the first name for the login.',
    lastName: 'Enter the last name for the login.',
    email:
      "Enter the email address for the login. This will become the user's username for their access credentials.",
    phone: 'Enter the phone number for the login.',
    relationship:
      'Enter the relationship between the person the login is for and the primary buyer.',
    notifications:
      'Select the desired notification settings for the login. Notifications are sent via text and email related to actions taken within the system.',
    notificationItems: {
      photos:
        "These notifications are sent when new home photo(s) are uploaded to the homeowner's photo gallery.",
      messages:
        'These notifications are sent when a homeowner sends a new message via the in-app messaging feature.',
      schedule:
        'These notifications are sent when a homeowner responds to any invitation sent to the homeowner via the scheduling feature.',
      documents:
        "These notifications are sent when new document(s) are uploaded to the homeowner's documents.",
      updates: 'These notifications are sent when a new update(s) are delivered to the homeowner.',
      general: 'These notifications are sent for events such as when a home changes phase.'
    },
    resetPassword: `Select "Yes" to generate a new password for the login. An email will be sent to the login's owner containing the new temporary password.`
  },
  homeGalleryTable: {
    order: 'Indicates the desired order of the corresponding images.'
  },
  eventsForm: {
    name: 'Enter the event name',
    description: 'Enter a description of the event',
    rsvpRequired: 'Choose whether or not you will require RSVPs from your invitees',
    estimatedDuration: 'Please select the estimated duration of the event, in hours'
  },
  documentForm: {
    name: 'Enter the name of the document.',
    description: 'Enter the description of the document.',
    file: 'File attached to the document.',
    phases: 'Select building phases of the document.',
    communities:
      'Select all communities the document should have been assigned to. Check all that apply.'
  },
  homeDocumentForm: {
    name: 'Enter the name of the document.',
    description: 'Enter the description of the document.',
    file: 'File attached to the document.',
    phasesIds: 'Select building phases of the document.'
  },
  chatsTable: {
    updatedAt: 'Indicates the date of the last message.',
    division: 'Indicates the division of the conversation.',
    community: 'Indicates the community of the conversation.',
    address: 'Indicates the address of the home.',
    contactName: 'Indicates the name of the contact.',
    buyer: 'Indicates the buyer in the conversation.'
  },
  newMessage: 'Type message to send'
};
